export default __webpack_public_path__ + "61bc4fa4087e13ed7a5ae6c4694a4b62.png";